import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = ({ onGetStarted, onLearnMore }) => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-6 md:mb-8">
          <Icon name="Rocket" size={40} className="text-primary md:w-12 md:h-12 lg:w-14 lg:h-14" />
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6">
          Ready to Transform Your Classroom?
        </h2>

        <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-8 md:mb-10 max-w-2xl mx-auto">
          Start creating engaging learning experiences today. No credit card required. Free for educators.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-10">
          <Button 
            size="lg" 
            iconName="Sparkles" 
            iconPosition="left"
            onClick={onGetStarted}
            className="w-full sm:w-auto"
          >
            Get Started Free
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            iconName="PlayCircle" 
            iconPosition="left"
            onClick={onLearnMore}
            className="w-full sm:w-auto"
          >
            Watch Demo
          </Button>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 text-sm text-muted-foreground">
          <div className="flex items-center">
            <Icon name="Check" size={18} className="text-success mr-2" />
            <span>Free forever for teachers</span>
          </div>
          <div className="flex items-center">
            <Icon name="Check" size={18} className="text-success mr-2" />
            <span>No credit card required</span>
          </div>
          <div className="flex items-center">
            <Icon name="Check" size={18} className="text-success mr-2" />
            <span>Setup in 5 minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;